import React, { useState, useEffect, useContext } from "react";
import "../assets/css/component-home-meet.css";
import { list } from "../services/liste-images-meet";
import InputText from "./InputText";
import { MdKeyboard, MdAddCircle } from "react-icons/md";
import { PiWarningFill } from "react-icons/pi";
import { ThemeContext } from "../contexts/ThemeContext";
import { AuthContext } from "../contexts/AuthContext";
import AlertNotificationInfo from "./AlertNotificationInfo";
import MeetInputForCode from "./Meet/MeetInputForCode";
import ModalMedium from "./ModalMedium";
import {
  generateCodeAndMeeting,
  createAllWebTRCTransports,
} from "../services/mediasoup-client";
import { socket } from "../services/socket";
import { useMeeting } from "../hooks/useMeeting";

export default function Meet() {
  const [value, setValue] = useState("");
  const [code, setCode] = useState("");
  const [imgNumber, setImgNumber] = useState(0);
  const [displayCopy, setDisplayCopy] = useState(false);
  const [messageJoinBoolean, setMessageJoinBoolean] = useState(false);
  const { theme } = useContext(ThemeContext);
  const [displayModalMedium, setDisplayModalMedium] = useState(false);
  const { user } = useContext(AuthContext);
  const { isMeetingActive } = useMeeting();
  const [hasActiveMeeting, setHasActiveMeeting] = useState(false);
  const [isClearing, setIsClearing] = useState(false);
  const [message, setMessage] = useState("");
  const [meetingId, setMeetingId] = useState("");
  const [textColor, setTextColor] = useState(
    theme === "light" ? "#000" : "#fff"
  );

  // Récupérer le code meeting depuis sessionStorage (envoyé par MeetingInviteCard)
  useEffect(() => {
    const savedCode = sessionStorage.getItem("meetingCode");
    if (savedCode) {
      setValue(savedCode);
      sessionStorage.removeItem("meetingCode");
    }
  }, []);

  // Vérifier côté client + serveur si une réunion est déjà active
  useEffect(() => {
    if (isMeetingActive) {
      setHasActiveMeeting(true);
      return;
    }
    // Double vérification côté serveur
    socket.emit("check_active_meeting", user.userId, (res) => {
      setHasActiveMeeting(res.active);
    });
  }, [isMeetingActive, user.userId]);

  useEffect(() => {
    if (imgNumber < list.length) {
      setTimeout(() => {
        setImgNumber(imgNumber + 1);
      }, 5000);
    } else {
      setImgNumber(-1 + 1);
    }
  }, [imgNumber]);

  useEffect(() => {
    setTextColor(theme === "light" ? "#000" : "#fff");
  }, [theme]);

  async function handleMeetingCreation() {
    try {
      const { accessCode, meetingId } = await generateCodeAndMeeting(user);
      setCode(accessCode);
      setMeetingId(meetingId);
      setMessage("Le code d'accès suivant n'est disponible que pendant 3h");
      setTimeout(() => {
        setMessage("");
      }, 27000);
    } catch (err) {
      console.error("Erreur :", err.message);
    }
  }

  async function handleMeetingCreateTransports(key = null) {
    try {
      await createAllWebTRCTransports(user, {
        meetingId,
        accessCode: key || code,
        setMeetingId,
        setCode,
        setMessageJoinBoolean,
      });
      setDisplayModalMedium(true);
    } catch (err) {
      console.error("Erreur :", err.message);
      alert(err.message);
    }
  }

  useEffect(() => {
    setTimeout(() => setDisplayCopy(false), 5000);
  }, [displayCopy]);

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setDisplayCopy(true);
      })
      .catch((err) => {
        console.error("Erreur de copie :", err);
      });
  };

  return (
    <>
      {!displayModalMedium ? (
        <>
          {displayCopy ? (
            <AlertNotificationInfo
              message="Code copié !"
              setCopyText={setDisplayCopy}
            />
          ) : (
            <></>
          )}

          <div className="row">
            <div className="col col-12 col-md-8">
              <div
                id="large-message"
                className="text-justify"
                style={{ color: textColor }}
              >
                Des réunions fluides et interactives.
                <br />
                Une collaboration en temps réel, sans limites.
              </div>
              <div
                id="small-message"
                className="text-justify"
                style={{ color: textColor }}
              >
                Le service que nous avons créé pour les réunions d'affaires
                sécurisées. <br />
                Afin de le rendre gratuit et accessible à tous.
              </div>

              {hasActiveMeeting ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "14px 18px",
                    borderRadius: "12px",
                    marginTop: "24px",
                    backgroundColor:
                      theme === "dark"
                        ? "rgba(239, 68, 68, 0.12)"
                        : "#fef2f2",
                    color: theme === "dark" ? "#fca5a5" : "#dc2626",
                    fontSize: "1rem",
                    lineHeight: 1.5,
                  }}
                >
                  <PiWarningFill
                    style={{ fontSize: "24px", flexShrink: 0 }}
                  />
                  <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <span>
                      Vous participez déjà à une réunion en cours sur cet
                      appareil. Veuillez quitter la réunion active avant d'en
                      rejoindre ou créer une autre.
                    </span>
                    <button
                      disabled={isClearing}
                      onClick={() => {
                        setIsClearing(true);
                        socket.emit("force_clear_active_meeting", user.userId, (res) => {
                          setIsClearing(false);
                          if (res.success) {
                            setHasActiveMeeting(false);
                          } else {
                            setMessage(res.message);
                          }
                        });
                      }}
                      style={{
                        alignSelf: "flex-start",
                        padding: "6px 14px",
                        borderRadius: "8px",
                        border: "none",
                        backgroundColor: theme === "dark" ? "#dc2626" : "#ef4444",
                        color: "#fff",
                        fontSize: "0.85rem",
                        cursor: isClearing ? "not-allowed" : "pointer",
                        opacity: isClearing ? 0.6 : 1,
                      }}
                    >
                      {isClearing ? "Nettoyage..." : "Ce n'est pas normal ? Forcer le nettoyage"}
                    </button>
                  </div>
                </div>
              ) : (
                <div className="container">
                  <div className="row">
                    <div
                      className={`col-12 col-md-6 ${
                        code === "" ? "mt-4" : ""
                      }`}
                      style={{
                        cursor: "pointer",
                        paddingTop: `${code === "" ? "1.8rem" : "1.5rem"}`,
                      }}
                    >
                      {code === "" ? (
                        <button
                          className="w-100 border-none generer-un-code-de-reunion"
                          style={{
                            height: "2.4rem",
                            borderRadius: "1.2rem",
                            color: "white",
                            backgroundColor: "#096ae7",
                            cursor: "pointer",
                            fontSize: "1.2rem",
                            textAlign: "center",
                            position: "relative",
                          }}
                          onClick={handleMeetingCreation}
                        >
                          <MdAddCircle
                            style={{
                              fontSize: "25px",
                              marginRight: "5px",
                            }}
                          />
                          Génerer un code de réunion
                        </button>
                      ) : (
                        <MeetInputForCode
                          code={code}
                          message={message}
                          textColor={textColor}
                          displayCopy={displayCopy}
                          handleCopy={handleCopy}
                          setDisplayCopy={setDisplayCopy}
                        />
                      )}
                    </div>
                    <div
                      className={`col-12 col-md-6 my-4 `}
                      style={{ position: "relative" }}
                    >
                      <MdKeyboard
                        style={{
                          position: "absolute",
                          color: textColor,
                          top: "36px",
                          zIndex: 2,
                          fontSize: "25px",
                        }}
                      />
                      <InputText
                        label="Saisir le code d'une réunion"
                        col={`w-100`}
                        placeholder="Le code de la réunion que vous souhaitez rejoindre."
                        value={value}
                        onChange={(evt) => {
                          setValue(evt.target.value);
                        }}
                        readOnly={false}
                        inputClass="padding-left-25"
                      />
                    </div>
                    <div
                      className={`col-12 mb-3 col-md-6 ${
                        code === "" ? " d-none" : ""
                      }`}
                    >
                      <button
                        onClick={() => {
                          handleMeetingCreateTransports(code);
                        }}
                        className="text-white border-none  w-100"
                        style={{
                          fontSize: "1.2rem",
                          height: "2.4rem",
                          borderRadius: "1.2rem",
                          textAlign: "center",
                          backgroundColor: "#096ae7",
                        }}
                      >
                        Démarrer une nouvelle une réunion
                      </button>
                    </div>

                    <div
                      className={`col-12 ${code === "" ? "" : "col-md-6"}`}
                    >
                      <button
                        onClick={() => {
                          socket.emit(
                            "checker_valid_code",
                            value,
                            (checker) => {
                              if (value.length >= 16 && checker?.valid) {
                                handleMeetingCreateTransports(code || value);
                              } else if (checker?.reason === "full") {
                                alert(
                                  "La réunion est complète (25 participants maximum)"
                                );
                              } else if (checker?.reason === "expired") {
                                alert(
                                  "Ce code de réunion a expiré (validité 3h)"
                                );
                              } else {
                                alert("Veuillez saisir un code valide");
                              }
                            }
                          );
                        }}
                        className="text-white border-none w-100"
                        style={{
                          fontSize: "1.2rem",
                          height: "2.4rem",
                          borderRadius: "1.2rem",
                          textAlign: "center",
                          backgroundColor: "#096ae7",
                        }}
                      >
                        {messageJoinBoolean
                          ? "Joindre la réunion"
                          : "Vérifier le code saisi"}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="mt-3 my-right-div-pour-masquer-img d-none d-sm-block animate__slow col col-md-4 animate__animated animate__pulse animate__infinite">
              <img
                src={list[imgNumber]}
                alt="_"
                style={{ maxHeight: "330px", cursor: "wait", maxWidth: "100%" }}
                className="max-with-120-for-pc"
              />
            </div>
          </div>
        </>
      ) : (
        <ModalMedium
          theme={theme}
          datas={{
            meetingId,
            displayModalMedium,
            setDisplayModalMedium,
            accessCode: code || value,
          }}
        />
      )}
    </>
  );
}
